import { formatDate } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-create-bond',
  templateUrl: './create-bond.component.html',
  styleUrls: ['./create-bond.component.scss']
})
export class CreateBondComponent {

  idCompany: any = 1;
  formNewPass: FormGroup = new FormGroup({});
  formType: string = 'amount';
  editBond: boolean = false;

  //Start-end dates
  typeDatepicker!: string;
  startStringDate!: any;
  endStringDate!: any;
  startDate!: NgbDate;
  endDate!: NgbDate;
  hourInit!: any;
  minuteInit!: any;
  hourEnd!: any;
  minuteEnd!: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<CreateBondComponent>,
    private formBuilder: FormBuilder, public formatter: NgbDateParserFormatter) { }

  ngOnInit(): void {
    this.data ? this.idCompany = this.data.idCompany : null;
    this.editBond = this.data?.edit;
    this.formNewPass = this.formBuilder.group({
      name: ['', Validators.required],
      type: ['amount', Validators.required],
      cuantity: ['', Validators.required],
      start_date: [],
      end_date: [],
    });
    if(this.data.object) {
      this.formNewPass.patchValue(this.data.object);
    }
  }

  ngAfterViewInit() {
  }

  cancelNew() {
    this.dialogRef.close();
  }

  nextStep() {
    if (this.formNewPass.valid) {
      // Indicar abrir select place
      this.dialogRef.close({ bond: this.formNewPass.value });
    }
  }

  saveStartDate(event: any) {
    const date = new Date(event);
    this.formNewPass.get('start_date').setValue(formatDate(date, 'yyyy-MM-dd', 'es'));
  }

  saveEndDate(event: any) {
    const date = new Date(event);
    this.formNewPass.get('end_date').setValue(formatDate(date, 'yyyy-MM-dd ', 'es'));
  }

  changeHourInit(event: any) {
    this.hourInit = event;
    this.saveConfig();
  }

  changeMinuteInit(event: any) {
    this.minuteInit = event;
    this.saveConfig();
  }

  changeHourEnd(event: any) {
    this.hourEnd = event;
    this.saveConfig();
  }

  changeMinuteEnd(event: any) {
    this.minuteEnd = event;
    this.saveConfig();
  }

  saveConfig() {
    if (this.hourInit && this.minuteInit != null) {
      const dateInit = this.formNewPass.value.start_date;
      if (dateInit) {
        dateInit.setHours(this.hourInit);
        dateInit.setMinutes(this.minuteInit);
        this.formNewPass.value.start_date = dateInit;
      }
    }

    if (this.hourEnd && this.minuteEnd != null) {
      const dateEnd = this.formNewPass.value.end_date;
      if (dateEnd) {
        dateEnd.setHours(this.hourEnd);
        dateEnd.setMinutes(this.minuteEnd);
        this.formNewPass.value.end_date = dateEnd;
      }
    }
  }

  openDatePicker(type: string) {
    if (this.typeDatepicker) {
      this.typeDatepicker = null;
      return;
    }
    this.typeDatepicker = type;
  }

  saveDate(event: any) {
    if (event) {
      const date = new Date(this.formatter.format(event));
      date.setHours(0);
      date.setMinutes(0);
      if (this.typeDatepicker == 'start') {
        this.startDate = event;
        this.formNewPass.controls['start_date'].setValue(date);
        this.startStringDate = formatDate(date, 'dd/MM/yyyy', 'es');
      }
      if (this.typeDatepicker == 'end') {
        this.endDate = event;
        this.formNewPass.controls['end_date'].setValue(date);
        this.endStringDate = formatDate(date, 'dd/MM/yyyy', 'es');
      }
    }
    this.saveConfig();
    this.typeDatepicker = null;
  }

}

